import React from 'react';
import styled from 'styled-components/macro';

const ModalContent = styled.div`
  max-height: 70vh;
  overflow: auto;
`;


const Content: React.FC = (props) => {
  return <ModalContent className="modalContent">{props.children}</ModalContent>;
};

export default Content;
